// src/billing/stripeLink.js — Stripe's payment link for a charge the bank wants confirmed (3-D Secure), v204.
//
// The backend relays Stripe's `hosted_invoice_url` (a 402 PAYMENT_ACTION_REQUIRED, a 409 PAYMENT_PENDING, or
// `payment_pending` on GET /billing/subscription). ⭐ It opens in a NEW TAB: Stripe's invoice page has no way back
// to us, so a same-tab redirect would strand the user there; the plans page re-reads when they return.
// ⛔ https only — never a host allowlist: Stripe can serve its hosted pages from a custom domain, and an allowlist
// would then silently remove the button. A link that fails the check gets no button (the email still carries it).

/** The URL when it is an absolute https URL, else null. */
export function safeHttpsUrl(value) {
  if (typeof value !== 'string' || !value) return null;
  try {
    return new URL(value).protocol === 'https:' ? value : null;
  } catch {
    return null;
  }
}

/** Open a safe URL in a new tab, detached from this page. @returns {boolean} whether it was opened */
export function openInNewTab(value) {
  const url = safeHttpsUrl(value);
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
